// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pluralize } from "@conklin/XDL/Utilities";
import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";

export interface OrderHistoryResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

export const resultCountStyles: OrderHistoryResultCountStyles = {};

const styles = resultCountStyles;

const OrderHistoryResultCount: FC<WidgetProps> = () => {
    const ordersDataView = useContext(OrdersDataViewContext);

    if (!ordersDataView.value || !ordersDataView.pagination) {
        return null;
    }

    const { totalItemCount } = ordersDataView.pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="orderHistory_resultCount">
            {/* XNG-Changes use pluralize */}
            {pluralize(totalItemCount, translate("Order"), { showNumber: true })}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistoryResultCount,
    definition: {
        group: "Order History",
        displayName: "Result Count",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
